export const SECTION_TEMPLATES = [
  {
    type: 'hero',
    label: '캐치프레이즈',
    maxCount: 1,
    templates: [
      { code: 'hero.centered-v1', label: '중앙 정렬형' },
      { code: 'hero.left-v1', label: '좌측 정렬형' },
    ],
  },
  {
    type: 'ga-intro',
    label: 'GA 조직 소개',
    maxCount: 1,
    templates: [
      { code: 'ga-intro.media-v1', label: '텍스트 + 이미지형' },
      { code: 'ga-intro.card-v1', label: '카드 강조형' },
    ],
  },
  {
    type: 'ceo-message',
    label: '대표 소개',
    maxCount: 1,
    templates: [
      { code: 'ceo-message.split-v1', label: '좌우 분할형' },
      { code: 'ceo-message.centered-v1', label: '중앙형' },
    ],
  },
  {
    type: 'business-intro',
    label: '사업단 소개',
    maxCount: 2,
    templates: [
      { code: 'business-intro.media-v1', label: '텍스트 + 이미지형' },
      { code: 'business-intro.cards-v1', label: '카드형' },
    ],
  },
  {
    type: 'benefits',
    label: '입사 혜택',
    maxCount: 2,
    templates: [
      { code: 'benefits.card-4-v1', label: '4카드형' },
      { code: 'benefits.list-v1', label: '리스트형' },
    ],
  },
  {
    type: 'stats',
    label: '성과/지표',
    maxCount: 2,
    templates: [
      { code: 'stats.grid-v1', label: '그리드형' },
    ],
  },
  {
    type: 'lead-form',
    label: '입사문의하기',
    maxCount: 1,
    templates: [
      { code: 'lead-form.recruit-career-v1', label: '리크루팅 지원형' },
      { code: 'lead-form.recruit-basic-v1', label: '간편 지원형' },
    ],
  },
  {
    type: 'contact',
    label: '문의 정보',
    maxCount: 1,
    templates: [
      { code: 'contact.centered-v1', label: '중앙형' },
    ],
  },
]

export const SECTION_TYPE_LABELS = Object.fromEntries(
  SECTION_TEMPLATES.map((item) => [item.type, item.label])
)

const GENERATED_ORG_ASSET_BASE = '/org-homepage-assets/generated'

function orgImage(fileName) {
  return `${GENERATED_ORG_ASSET_BASE}/${fileName}`
}

const SAMPLE_ASSETS = {
  hero: orgImage('org-trust-blue-hero.jpg'),
  content: orgImage('org-growth-network-hero.jpg'),
  fastHero: orgImage('org-recruiting-coaching-hero.jpg'),
  fastContent: orgImage('org-training-system-hero.jpg'),
  brandHero: orgImage('org-leader-message-hero.jpg'),
  brandContent: orgImage('org-leader-message-hero.jpg'),
  videoHero: orgImage('org-training-system-hero.jpg'),
  videoContent: orgImage('org-training-system-hero.jpg'),
  conversionHero: orgImage('org-conversion-support-hero.jpg'),
  conversionContent: orgImage('org-conversion-support-hero.jpg'),
}

function createAsset(fileId, name = '기본 템플릿 이미지') {
  return { fileId, sourceType: 'library', assetCategory: 'TEMPLATE_SAMPLE', name }
}

function createBuiltinOrgAsset({ id, sectionType, slotKey, fileId, name, description, tags = [] }) {
  return {
    id,
    sectionType,
    slotKey,
    assetCategory: 'TEMPLATE_SAMPLE',
    name,
    description,
    imageFileId: fileId,
    previewImageFileId: fileId,
    tags,
  }
}

export const BUILTIN_ORG_HOMEPAGE_IMAGE_ASSETS = [
  {
    id: 'builtin-org-hero-trust-blue',
    sectionType: 'hero',
    slotKey: 'backgroundImage',
    name: '신뢰 중심 히어로',
    description: '조직 소개 첫 화면에 어울리는 차분한 블루 이미지',
    fileId: SAMPLE_ASSETS.hero,
    tags: ['히어로', '신뢰', '블루'],
  },
  {
    id: 'builtin-org-hero-growth-network',
    sectionType: 'hero',
    slotKey: 'backgroundImage',
    name: '성장 네트워크 히어로',
    description: '조직 성장과 협업을 강조하는 이미지',
    fileId: SAMPLE_ASSETS.content,
    tags: ['히어로', '성장', '네트워크'],
  },
  {
    id: 'builtin-org-hero-recruiting-coaching',
    sectionType: 'hero',
    slotKey: 'backgroundImage',
    name: '리크루팅 코칭 히어로',
    description: '빠른 정착과 실행 코칭을 표현하는 이미지',
    fileId: SAMPLE_ASSETS.fastHero,
    tags: ['히어로', '리크루팅', '코칭'],
  },
  {
    id: 'builtin-org-hero-city-trustwide',
    sectionType: 'hero',
    slotKey: 'backgroundImage',
    name: '도시 신뢰형 히어로',
    description: '전문성과 조직 규모감을 함께 보여주는 이미지',
    fileId: orgImage('org-hero-city-trustwide.jpg'),
    tags: ['히어로', '전문성', '조직 규모'],
  },
  {
    id: 'builtin-org-hero-premium-office',
    sectionType: 'hero',
    slotKey: 'backgroundImage',
    name: '프리미엄 오피스 히어로',
    description: '고급스럽고 차분한 조직 첫 화면에 적합합니다.',
    fileId: orgImage('org-hero-premium-office.jpg'),
    tags: ['히어로', '프리미엄', '오피스'],
  },
  {
    id: 'builtin-org-hero-advisor-coaching',
    sectionType: 'hero',
    slotKey: 'backgroundImage',
    name: '코칭 중심 히어로',
    description: '교육과 동행을 앞세운 리크루팅 화면에 어울립니다.',
    fileId: orgImage('org-hero-advisor-coaching.jpg'),
    tags: ['히어로', '코칭', '교육'],
  },
  {
    id: 'builtin-org-intro-growth-network',
    sectionType: 'ga-intro',
    slotKey: 'mainImage',
    name: '조직 성장 소개',
    description: 'GA 조직 소개와 협업 문화 섹션에 적합합니다.',
    fileId: SAMPLE_ASSETS.content,
    tags: ['조직소개', '성장'],
  },
  {
    id: 'builtin-org-intro-training-system',
    sectionType: 'ga-intro',
    slotKey: 'mainImage',
    name: '교육 시스템 소개',
    description: '온보딩·교육 체계를 소개할 때 어울립니다.',
    fileId: SAMPLE_ASSETS.fastContent,
    tags: ['조직소개', '교육'],
  },
  {
    id: 'builtin-org-intro-collaboration-grid',
    sectionType: 'ga-intro',
    slotKey: 'mainImage',
    name: '협업 네트워크 소개',
    description: '조직 문화와 협업 구조를 보여주는 대표 이미지',
    fileId: orgImage('org-intro-collaboration-grid.jpg'),
    tags: ['조직소개', '협업', '네트워크'],
  },
  {
    id: 'builtin-org-intro-operations-system',
    sectionType: 'ga-intro',
    slotKey: 'mainImage',
    name: '운영 시스템 소개',
    description: '관리 체계와 지원 시스템을 설명하는 섹션에 적합합니다.',
    fileId: orgImage('org-intro-operations-system.jpg'),
    tags: ['조직소개', '운영', '시스템'],
  },
  {
    id: 'builtin-org-intro-education-room',
    sectionType: 'ga-intro',
    slotKey: 'mainImage',
    name: '교육 환경 소개',
    description: '교육장·온보딩·성장 프로그램 소개에 어울립니다.',
    fileId: orgImage('org-intro-education-room.jpg'),
    tags: ['조직소개', '교육', '온보딩'],
  },
  {
    id: 'builtin-org-ceo-leader-message',
    sectionType: 'ceo-message',
    slotKey: 'mainImage',
    name: '리더 메시지',
    description: '대표 소개와 조직 철학 섹션에 맞춘 이미지',
    fileId: SAMPLE_ASSETS.brandContent,
    tags: ['대표소개', '리더십'],
  },
  {
    id: 'builtin-org-ceo-warm-desk',
    sectionType: 'ceo-message',
    slotKey: 'mainImage',
    name: '따뜻한 대표 메시지',
    description: '대표 인사말을 부드럽고 신뢰감 있게 보조합니다.',
    fileId: orgImage('org-ceo-message-warm-desk.jpg'),
    tags: ['대표소개', '철학', '신뢰'],
  },
  {
    id: 'builtin-org-ceo-vision-stage',
    sectionType: 'ceo-message',
    slotKey: 'mainImage',
    name: '비전 제시형 메시지',
    description: '조직의 방향성과 비전을 강조하는 이미지',
    fileId: orgImage('org-ceo-message-vision-stage.jpg'),
    tags: ['대표소개', '비전', '방향성'],
  },
  {
    id: 'builtin-org-business-training-system',
    sectionType: 'business-intro',
    slotKey: 'mainImage',
    name: '사업단 성장 체계',
    description: '사업단 소개와 성장 경로 설명에 적합합니다.',
    fileId: SAMPLE_ASSETS.videoContent,
    tags: ['사업단', '성장체계'],
  },
  {
    id: 'builtin-org-business-branch-network',
    sectionType: 'business-intro',
    slotKey: 'mainImage',
    name: '사업단 네트워크',
    description: '지점·팀·사업단 확장 구조를 보여주기 좋습니다.',
    fileId: orgImage('org-business-branch-network.jpg'),
    tags: ['사업단', '네트워크', '확장'],
  },
  {
    id: 'builtin-org-business-growth-roadmap',
    sectionType: 'business-intro',
    slotKey: 'mainImage',
    name: '성장 로드맵',
    description: '입사 후 성장 경로와 운영 단계를 설명하는 이미지',
    fileId: orgImage('org-business-growth-roadmap.jpg'),
    tags: ['사업단', '성장', '로드맵'],
  },
  {
    id: 'builtin-org-business-planning-board',
    sectionType: 'business-intro',
    slotKey: 'mainImage',
    name: '운영 계획 보드',
    description: '사업 운영과 교육 계획을 시각적으로 보조합니다.',
    fileId: orgImage('org-business-planning-board.jpg'),
    tags: ['사업단', '운영', '교육'],
  },
  {
    id: 'builtin-org-lead-form-conversion-support',
    sectionType: 'lead-form',
    slotKey: 'sideImage',
    name: '지원 전환 보조 이미지',
    description: '입사문의 폼 옆 보조 이미지로 사용하기 좋습니다.',
    fileId: SAMPLE_ASSETS.conversionHero,
    tags: ['입사문의', '전환'],
  },
  {
    id: 'builtin-org-lead-form-recruiting-coaching',
    sectionType: 'lead-form',
    slotKey: 'sideImage',
    name: '리크루팅 상담 보조 이미지',
    description: '지원 상담과 코칭 흐름을 표현합니다.',
    fileId: SAMPLE_ASSETS.fastHero,
    tags: ['입사문의', '코칭'],
  },
  {
    id: 'builtin-org-lead-form-career-apply',
    sectionType: 'lead-form',
    slotKey: 'sideImage',
    name: '커리어 지원형',
    description: '입사 문의와 커리어 전환 신청에 어울리는 보조 이미지',
    fileId: orgImage('org-lead-form-career-apply.jpg'),
    tags: ['입사문의', '커리어', '지원'],
  },
  {
    id: 'builtin-org-lead-form-consulting-soft',
    sectionType: 'lead-form',
    slotKey: 'sideImage',
    name: '부드러운 상담형',
    description: '부담 없는 상담 신청 흐름에 적합합니다.',
    fileId: orgImage('org-lead-form-consulting-soft.jpg'),
    tags: ['입사문의', '상담', '문의'],
  },
  {
    id: 'builtin-org-lead-form-onboarding-path',
    sectionType: 'lead-form',
    slotKey: 'sideImage',
    name: '온보딩 경로형',
    description: '입사 후 정착과 성장 경로를 함께 보여줍니다.',
    fileId: orgImage('org-lead-form-onboarding-path.jpg'),
    tags: ['입사문의', '온보딩', '성장'],
  },
].map(createBuiltinOrgAsset)

const DEFAULT_SECTION_TYPES = ['hero', 'ga-intro', 'stats', 'ceo-message', 'business-intro', 'benefits', 'lead-form', 'contact']

const LEAD_FORM_PRESETS = {
  'lead-form.recruit-basic-v1': [
    { key: 'customerName', label: '이름', type: 'text', required: true },
    { key: 'customerPhone', label: '연락처', type: 'tel', required: true },
    {
      key: 'careerType',
      label: '지원경력',
      type: 'select',
      required: true,
      options: ['신입', '경력'],
    },
    {
      key: 'birthDate',
      label: '생년월일 (예: 890211)',
      type: 'text',
      required: true,
    },
    {
      key: 'preferredRegion',
      label: '희망근무지역',
      type: 'select',
      required: false,
      options: ['서울특별시', '부산광역시', '대구광역시', '인천광역시', '광주광역시', '대전광역시', '울산광역시', '세종특별자치시', '경기도', '충청북도', '충청남도', '전북특별자치도', '전라남도', '경상북도', '경상남도', '강원특별자치도', '제주특별자치도'],
    },
    { key: 'message', label: '지원 동기/문의', type: 'textarea', required: false },
  ],
  'lead-form.recruit-career-v1': [
    { key: 'customerName', label: '이름', type: 'text', required: true },
    { key: 'customerPhone', label: '연락처', type: 'tel', required: true },
    {
      key: 'careerType',
      label: '지원 경력',
      type: 'select',
      required: true,
      options: ['신입', '경력'],
    },
    {
      key: 'careerCompanyType',
      label: '경력회사',
      type: 'select',
      required: false,
      options: ['손해보험', '생명보험', 'GA'],
    },
    {
      key: 'birthDate',
      label: '생년월일 (예: 890211)',
      type: 'text',
      required: true,
    },
    {
      key: 'preferredRegion',
      label: '희망근무지역',
      type: 'select',
      required: false,
      options: ['서울특별시', '부산광역시', '대구광역시', '인천광역시', '광주광역시', '대전광역시', '울산광역시', '세종특별자치시', '경기도', '충청북도', '충청남도', '전북특별자치도', '전라남도', '경상북도', '경상남도', '강원특별자치도', '제주특별자치도'],
    },
    { key: 'preferredContactTime', label: '희망 연락 시간', type: 'text', required: false },
    { key: 'message', label: '지원 동기/문의', type: 'textarea', required: false },
  ],
}

export function getSectionMeta(type) {
  return SECTION_TEMPLATES.find((item) => item.type === type) || null
}

export function getTemplateMeta(templateCode) {
  for (const section of SECTION_TEMPLATES) {
    const match = section.templates.find((item) => item.code === templateCode)
    if (match) return { ...match, type: section.type, sectionLabel: section.label }
  }
  return null
}

function createHeroSection(templateCode = 'hero.centered-v1') {
  const leftMode = templateCode === 'hero.left-v1'
  return {
    type: 'hero',
    templateCode,
    enabled: true,
    content: {
      eyebrow: leftMode ? 'Fast Start Recruiting' : 'Recruiting Landing',
      title: leftMode
        ? '빠르게 적응하고\n오래 성장하는 커리어를 시작하세요'
        : '고객의 신뢰를 연결하는\n당신의 커리어를 시작하세요',
      subtitle: leftMode
        ? '현장 동행과 실행 코칭, 주간 리뷰로 빠른 적응과 성장을 돕습니다.'
        : '검증된 교육 시스템, 현장 밀착 코칭, 빠른 정착 지원으로 성장하는 조직의 리크루팅 홈페이지를 바로 시작할 수 있습니다.',
      ctaText: leftMode ? '빠른 상담 신청' : '입사문의하기',
      ctaLink: '#lead-form',
    },
    assets: {
      backgroundImage: createAsset(leftMode ? SAMPLE_ASSETS.fastHero : SAMPLE_ASSETS.hero, leftMode ? '실행형 히어로 이미지' : '균형형 히어로 이미지'),
    },
    style: {},
  }
}

function createTemplateOneHeroSection(templateCode = 'hero.centered-v1') {
  return {
    type: 'hero',
    templateCode,
    enabled: true,
    content: {
      eyebrow: 'Organization Landing',
      title: '단순한 영업을 넘어,\n사람을 향한 시스템을 만듭니다',
      subtitle: '교육, 정착, 리더 육성까지 연결된 성장 시스템으로 오래 일할 수 있는 조직 문화를 소개하는 균형형 기본 템플릿입니다.',
      ctaText: '입사문의하기',
      ctaLink: '#lead-form',
    },
    assets: {
      backgroundImage: createAsset(SAMPLE_ASSETS.hero, '기본템플릿1 히어로 이미지'),
    },
    style: {},
  }
}

function createIntroSection(type, templateCode, titlePlaceholder) {
  const defaultPayload = {
    'ga-intro': {
      eyebrow: templateCode === 'ga-intro.card-v1' ? 'Why Us' : 'GA Intro',
      title: templateCode === 'ga-intro.card-v1'
        ? '빠른 정착과 실행 지원이\n왜 중요한지 먼저 보여줍니다'
        : '고객 중심의 영업 문화를 만드는\n우리 조직을 소개합니다',
      subtitle: templateCode === 'ga-intro.card-v1' ? '실행 중심 운영, 빠른 피드백, 함께 성장하는 문화' : '현장 실행과 협업을 동시에 강화합니다',
      body: templateCode === 'ga-intro.card-v1'
        ? '혜택과 지원 체계를 먼저 보여준 뒤, 조직 소개로 자연스럽게 이어지도록 설계할 수 있는 카드 강조형 소개 섹션입니다.'
        : '실전 중심 교육과 체계적인 영업 지원, 조직장과 설계사가 함께 성장하는 문화를 바탕으로 안정적인 정착과 장기 성장을 돕습니다.',
      image: templateCode === 'ga-intro.card-v1' ? SAMPLE_ASSETS.fastContent : SAMPLE_ASSETS.content,
    },
    'ceo-message': {
      eyebrow: templateCode === 'ceo-message.centered-v1' ? 'Brand Message' : 'Leader Message',
      title: templateCode === 'ceo-message.centered-v1' ? '리더의 철학을 중심에 둔 소개' : '대표 소개',
      subtitle: templateCode === 'ceo-message.centered-v1' ? '신뢰와 운영 원칙을 먼저 전합니다' : '성과보다 먼저 사람의 성장을 봅니다',
      body: templateCode === 'ceo-message.centered-v1'
        ? '브랜드 신뢰와 장기 성장 관점을 먼저 설득하고 싶은 경우 적합한 중앙형 리더 메시지 섹션입니다.'
        : '좋은 영업은 개인의 역량만으로 완성되지 않습니다. 함께 성장할 수 있는 시스템, 신뢰할 수 있는 리더십, 고객에게 진심으로 다가가는 문화를 통해 오래 일할 수 있는 조직을 만들고 있습니다.',
      image: templateCode === 'ceo-message.centered-v1' ? SAMPLE_ASSETS.brandContent : SAMPLE_ASSETS.content,
    },
    'business-intro': {
      eyebrow: templateCode === 'business-intro.cards-v1' ? 'Team Structure' : 'Growth Path',
      title: titlePlaceholder,
      subtitle: templateCode === 'business-intro.cards-v1' ? '역할과 팀 구조를 직관적으로 보여주는 카드형 섹션' : '온보딩, 실행, 리더 성장 흐름을 설명하는 미디어형 섹션',
      body: templateCode === 'business-intro.cards-v1'
        ? '사업단별 역할을 카드형으로 보여주면서 지원자가 합류 후 어떤 팀과 어떤 순서로 연결되는지 쉽게 이해하도록 구성합니다.'
        : '합류 후 30일, 90일, 180일 성장 경로와 실행 지원 체계를 미디어 이미지와 함께 설명할 수 있습니다.',
      image: templateCode === 'business-intro.cards-v1' ? SAMPLE_ASSETS.content : SAMPLE_ASSETS.fastContent,
    },
  }[type] || {}

  return {
    type,
    templateCode,
    enabled: true,
    content: {
      eyebrow: defaultPayload.eyebrow || '',
      title: defaultPayload.title || titlePlaceholder,
      subtitle: defaultPayload.subtitle || '',
      body: defaultPayload.body || '설명 문구를 입력해주세요',
      items: type === 'business-intro' ? [
        ...(templateCode === 'business-intro.cards-v1'
          ? [
            { title: '온보딩 코치', body: '첫 상담 준비, 일정 운영, 루틴 점검까지 초반 적응을 밀착 지원합니다.' },
            { title: '성장 매니저', body: '제안력과 전환율을 높이는 실전 코칭으로 생산성을 끌어올립니다.' },
            { title: '리더 트랙', body: '성과가 쌓인 뒤 팀 운영과 채용까지 연결되는 확장 경로를 제공합니다.' },
          ]
          : [
            { title: '30일 적응 구간', body: '기초 학습, 일정 정리, 활동 루틴을 빠르게 세팅합니다.' },
            { title: '90일 실행 구간', body: '상담 동행과 피드백으로 실제 전환 성과를 만드는 구간입니다.' },
            { title: '180일 확장 구간', body: '성과 고도화와 리더 육성 트랙으로 다음 단계 성장을 연결합니다.' },
          ]),
      ] : undefined,
    },
    assets: {
      mainImage: defaultPayload.image ? createAsset(defaultPayload.image, '기본 소개 이미지') : {},
    },
    style: {},
  }
}

function createBenefitsSection(templateCode = 'benefits.card-4-v1') {
  return {
    type: 'benefits',
    templateCode,
    enabled: true,
    content: {
      title: templateCode === 'benefits.list-v1' ? '입사 후 성장 로드맵' : '입사 혜택',
      subtitle: templateCode === 'benefits.list-v1'
        ? '정착, 실행, 확장 단계에서 무엇을 받게 되는지 흐름 중심으로 보여줄 수 있습니다.'
        : '정착부터 성장까지, 현장에서 체감하는 지원을 설계했습니다.',
      items: templateCode === 'benefits.list-v1'
        ? [
          { title: '1주차 온보딩', body: '기초 교육, 상담 준비 체크리스트, 필수 자료 세팅을 지원합니다.' },
          { title: '2~4주차 동행', body: '실전 상담 동행과 대화 흐름 피드백으로 첫 실무 감각을 익힙니다.' },
          { title: '월간 리뷰', body: '활동량과 전환율을 함께 리뷰하며 다음 할 일을 빠르게 정합니다.' },
          { title: '리더 연결', body: '성과 단계에 맞춰 팀 운영과 리더 트랙 기회를 안내합니다.' },
        ]
        : [
          { title: '정착 지원', body: '초기 활동에 필요한 기본 운영 가이드와 밀착 피드백을 제공합니다.' },
          { title: '교육 지원', body: '상품/상담/세일즈 스크립트까지 실전에 맞는 교육을 운영합니다.' },
          { title: '영업 지원', body: '현장 동행, DB 활용, 상담 프로세스 정비까지 함께합니다.' },
          { title: '성과 보상', body: '성과와 기여가 명확히 보이는 보상 구조를 제공합니다.' },
        ],
    },
    assets: {},
    style: {},
  }
}

function createStatsSection(templateCode = 'stats.grid-v1') {
  return {
    type: 'stats',
    templateCode,
    enabled: true,
    content: {
      title: '숫자로 보는 조직 성장',
      items: [
        { label: '누적 상담', value: '12,480+' },
        { label: '활동 설계사', value: '180+' },
        { label: '월 평균 교육', value: '24회' },
        { label: '정착 프로그램', value: '90일' },
      ],
    },
    assets: {},
    style: {},
  }
}

function createTemplateOneStatsSection(templateCode = 'stats.grid-v1') {
  return {
    type: 'stats',
    templateCode,
    enabled: true,
    content: {
      title: '숫자로 보는 우리 조직',
      items: [
        { label: '누적 상담', value: '12,800건' },
        { label: '활동 인원', value: '85명' },
        { label: '월 평균 교육', value: '24회' },
        { label: '제휴 거점', value: '12곳' },
      ],
    },
    assets: {},
    style: {},
  }
}

function createLeadFormSection(templateCode = 'lead-form.recruit-career-v1') {
  return {
    type: 'lead-form',
    templateCode,
    enabled: true,
    content: {
      title: '입사문의하기',
      subtitle: templateCode === 'lead-form.recruit-basic-v1'
        ? '핵심 정보만 남기면 빠르게 연락드리는 간편 지원형 폼입니다.'
        : '지원경력, 생년월일, 희망근무지역 등 기본 정보를 남겨주시면 담당자가 빠르게 검토 후 연락드립니다.',
      submitText: templateCode === 'lead-form.recruit-basic-v1' ? '간편 입사문의하기' : '입사문의하기',
      successMessage: '입사문의가 접수되었습니다. 빠르게 연락드리겠습니다.',
      fields: LEAD_FORM_PRESETS[templateCode] || LEAD_FORM_PRESETS['lead-form.recruit-basic-v1'],
    },
    assets: {
      sideImage: createAsset(
        templateCode === 'lead-form.recruit-basic-v1' ? SAMPLE_ASSETS.conversionContent : SAMPLE_ASSETS.content,
        templateCode === 'lead-form.recruit-basic-v1' ? '전환형 지원 이미지' : '기본 지원 이미지'
      ),
    },
    style: {},
  }
}

function createContactSection(templateCode = 'contact.centered-v1') {
  return {
    type: 'contact',
    templateCode,
    enabled: true,
    content: {
      title: '문의하기',
      address: '서울시 강남구 테헤란로 00, 00빌딩',
      phone: '010-0000-0000',
      email: 'recruit@example.com',
      kakaoLink: '',
    },
    assets: {},
    style: {},
  }
}

export function createTemplateOneLandingPagePreset() {
  return {
    templateId: 'default',
    meta: {
      title: '기본템플릿1',
      description: '조직 소개, 리크루팅, 문의 전환까지 바로 활용할 수 있는 조직홈페이지 기본 템플릿입니다.',
      keywords: '조직홈페이지, GA, 리크루팅, 기본템플릿',
    },
    style: { primaryColor: '#0f172a' },
    logoFileId: '',
    sections: [
      createTemplateOneHeroSection(),
      {
        ...createIntroSection('ga-intro', 'ga-intro.media-v1', 'GA 조직 소개'),
        content: {
          eyebrow: 'ABOUT US',
          title: '고객과 구성원이 함께 성장하는\n우리 조직을 소개합니다',
          subtitle: '현장 실행력과 성장 시스템을 함께 설계합니다',
          body: '이 기본 템플릿은 신입 정착, 경력 확장, 리더 육성까지 단계별 성장 구조를 자연스럽게 설명할 수 있도록 구성되어 있습니다.',
        },
      },
      createTemplateOneStatsSection(),
      {
        ...createIntroSection('ceo-message', 'ceo-message.split-v1', '대표 소개'),
        content: {
          eyebrow: 'Leader Message',
          title: '조직장 소개',
          subtitle: '김하늘 조직장',
          body: '좋은 조직은 개인의 역량만으로 완성되지 않습니다. 함께 성장할 수 있는 시스템, 신뢰할 수 있는 리더십, 고객에게 진심으로 다가가는 문화를 통해 오래 일할 수 있는 팀을 만들어가고 있습니다.',
        },
      },
      {
        ...createIntroSection('business-intro', 'business-intro.cards-v1', '조직 구조/팀 소개'),
        content: {
          eyebrow: 'Team Structure',
          title: '조직 구조/팀 소개',
          subtitle: '정착, 성장, 확장을 연결하는 3단계 운영',
          body: '조직도와 팀 운영 체계를 단순 소개에 그치지 않고, 지원자 입장에서 입사 후 어떤 성장 경로를 밟게 되는지 바로 이해할 수 있도록 구성했습니다.',
          items: [
            { title: '정착 지원팀', body: '입사 초기 적응, 일정 관리, 상담 루틴 정착을 밀착 지원합니다.' },
            { title: '영업 성장팀', body: '상품 제안, 상담 동행, 전환율 개선 코칭으로 성과를 끌어올립니다.' },
            { title: '리더 육성팀', body: '팀 확장과 채용 운영, 리더십 교육을 통해 다음 단계 성장을 돕습니다.' },
          ],
        },
      },
      {
        ...createIntroSection('business-intro', 'business-intro.media-v1', '교육/성장 프로그램'),
        content: {
          eyebrow: 'Growth Program',
          title: '교육/성장 프로그램',
          subtitle: '입사 후 30일, 90일, 180일 성장 설계를 한눈에',
          body: '정착 프로그램과 현장 동행, 성과 리뷰, 리더 육성으로 입사 후 단계별 성장을 돕습니다.',
          items: [
            { title: '첫 30일', body: '기초 학습, 일정 세팅, 초기 루틴 정착을 중심으로 진행합니다.' },
            { title: '90일 실행', body: '상담 동행과 실전 피드백으로 성과를 내는 흐름을 익힙니다.' },
            { title: '180일 확장', body: '리더 트랙과 팀 확장 가능성까지 연결해 다음 단계를 설계합니다.' },
          ],
        },
        assets: {
          mainImage: createAsset(SAMPLE_ASSETS.content, '기본템플릿1 성장 프로그램 이미지'),
        },
      },
      {
        ...createBenefitsSection('benefits.card-4-v1'),
        content: {
          title: '입사 혜택',
          subtitle: '입사 초기 정착부터 장기 성장까지 실제 현장에서 체감할 수 있는 지원을 제공합니다.',
          items: [
            { title: '초기 정착 지원', body: '초기 활동 기준 수립과 루틴 형성을 위한 온보딩 코칭을 제공합니다.' },
            { title: '실전 교육 지원', body: '상품, 상담, 고객 응대, 세일즈 스크립트까지 현장형 교육을 운영합니다.' },
            { title: '현장 영업 지원', body: '상담 동행, DB 활용, 제안서 보완 등 실전에 필요한 지원을 함께합니다.' },
            { title: '리더 성장 기회', body: '성과를 내는 설계사가 리더로 성장할 수 있는 육성 체계를 제공합니다.' },
          ],
        },
      },
      {
        ...createLeadFormSection('lead-form.recruit-career-v1'),
        content: {
          title: '입사문의하기',
          subtitle: '지원 경력과 희망 근무 지역 등 기본 정보를 남겨주시면 담당자가 빠르게 검토 후 연락드립니다.',
          submitText: '입사문의하기',
          successMessage: '입사문의가 접수되었습니다. 담당자가 확인 후 빠르게 연락드리겠습니다.',
          fields: LEAD_FORM_PRESETS['lead-form.recruit-career-v1'],
        },
      },
      {
        ...createContactSection('contact.centered-v1'),
        content: {
          title: '문의하기',
          address: '서울특별시 강남구 테헤란로 123, 8층',
          phone: '02-555-1234',
          email: 'contact@template1.example.com',
          kakaoLink: 'https://pf.kakao.com/_template1',
        },
      },
    ].map((section, index) => ({ ...section, order: index, id: `${section.type}-${index + 1}` })),
  }
}

export function createDefaultLandingPagePreset() {
  return createTemplateOneLandingPagePreset()
}

export function createSectionDraft(type, templateCode) {
  switch (type) {
    case 'hero':
      return createHeroSection(templateCode)
    case 'ga-intro':
      return createIntroSection('ga-intro', templateCode || 'ga-intro.media-v1', 'GA 조직 소개')
    case 'ceo-message':
      return createIntroSection('ceo-message', templateCode || 'ceo-message.split-v1', '대표 소개')
    case 'business-intro':
      return createIntroSection('business-intro', templateCode || 'business-intro.media-v1', '사업단 소개')
    case 'benefits':
      return createBenefitsSection(templateCode)
    case 'stats':
      return createStatsSection(templateCode)
    case 'lead-form':
      return createLeadFormSection(templateCode)
    case 'contact':
      return createContactSection(templateCode)
    default:
      return {
        type: type || 'custom',
        templateCode: templateCode || 'custom.rich-text-v1',
        enabled: true,
        content: { title: '', body: '' },
        assets: {},
        style: {},
      }
  }
}

export function getLeadFormPreset(templateCode) {
  return LEAD_FORM_PRESETS[templateCode] || LEAD_FORM_PRESETS['lead-form.recruit-basic-v1']
}

export { DEFAULT_SECTION_TYPES, SAMPLE_ASSETS }
